<template>
  <div>
    <!-- <div class="float-to-right">
      <b-button
        class="btn blue"
        @click="$router.replace('/flows/sla/create')">
        CREATE SLA
      </b-button>
    </div> -->
    <jListFlowSLA />
    <router-view/>
  </div>
</template>

<script>
import jListFlowSLA from './list/jListFlowSLA';

export default {
  // eslint-disable-next-line
  name: 'jFlowSLA',
  components: {
    jListFlowSLA,
  },
  mixins: [],
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  methods: {

  },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-sla/jFlowSLA.vue